module.exports = __webpack_public_path__ + "img/error-page-500.964035e.png";